import { Button, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CognitoUser } from 'amazon-cognito-identity-js';
import userPool from '../../util/cognito/userPool';
import { useSelector } from 'react-redux';
import { RootState } from '../../globalStore/store';

const RegistrationStep5: React.FC = () => {
  const username: string = useSelector((state: RootState) => state.user.userName);
  const resendConfirmationCode = () => {
    const user = new CognitoUser({ Username: username, Pool: userPool });

    user.resendConfirmationCode((err, result) => {
      if (err) {
        console.error('Error resending confirmation code:', err);
        return;
      }
      console.log('Confirmation code resent successfully:', result);
    });
  };
  const navigate = useNavigate();


  return(
    <>
      <Typography variant={'body2'} textAlign={"center"}>{"Az email címedre elküldtünk egy megerősítő üzenetet. Kérünk kattints a levélben található linkre, majd jelentkezz be."}</Typography>
        <Button onClick={()=>{navigate('/login')}} variant={"contained"} >{"Bejelentkezés"}</Button>

      <Typography variant={'body2'} textAlign={"center"}>{"Nem kaptad meg az emailt? Ellenőrizd a spam fiókot, vagy "}<span onClick={resendConfirmationCode} style={{textDecoration: 'underline', cursor: 'pointer'}}>{"küldj egy új kódot."}</span></Typography>
    </>
  )
}

export default RegistrationStep5;